/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const dataJacketList = /* GraphQL */ `
  query DataJacketList($userId: String) {
    dataJacketList(userId: $userId) {
      statusCode
      body {
        data_jacket_ids
        data_jacket_names
        data_jacket_industries
        my_data_jacket_ids
        my_data_jacket_names
        my_data_jacket_industries
        __typename
      }
      __typename
    }
  }
`;
export const dataJacket = /* GraphQL */ `
  query DataJacket($id: String, $userId: String) {
    dataJacket(id: $id, userId: $userId) {
      statusCode
      body {
        data_jacket_id
        data_jacket_name
        data_jacket_summary
        data_jacket_industry
        data_jacket_language
        data_jacket_homepage
        data_jacket_collection
        data_jacket_public
        data_jacket_scope
        data_jacket_price
        data_jacket_free_text
        data_jacket_publisher
        data_jacket_license
        data_jacket_right
        data_jacket_source
        data_jacket_update
        data_jacket_date_published
        data_jacket_date_update
        dataset_analysis
        analysis_results
        analysis_results_other
        data_jacket_counter_organization
        data_jacket_counter_department
        data_jacket_counter_mail
        data_jacket_counter_phone
        author
        created_date
        update_user
        update_date
        favorite_count
        user_favorite_flag
        __typename
      }
      __typename
    }
  }
`;
export const dataJacketIDs = /* GraphQL */ `
  query DataJacketIDs(
    $limit: Int
    $offset: Int
    $keyword: String
    $price: String
    $user: String
    $bookmarked: Boolean
    $relatedIndustry: String
    $availability: String
    $sortOrder: String
  ) {
    dataJacketIDs(
      limit: $limit
      offset: $offset
      keyword: $keyword
      price: $price
      user: $user
      bookmarked: $bookmarked
      relatedIndustry: $relatedIndustry
      availability: $availability
      sortOrder: $sortOrder
    ) {
      statusCode
      ids
      __typename
    }
  }
`;
export const termsOfUse = /* GraphQL */ `
  query TermsOfUse($id: String) {
    termsOfUse(id: $id) {
      statusCode
      body {
        term_id
        data_jacket_id
        data_rules
        information_management_category
        third_party_disclosure_requirement
        derived_data_right
        caution
        data_validity_start
        data_validity_end
        data_buyer_restriciting
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const contractPolicy = /* GraphQL */ `
  query ContractPolicy($id: String) {
    contractPolicy(id: $id) {
      statusCode
      body {
        contract_policy_id
        data_jacket_id
        term_id
        form_of_contract
        intended_use
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const dataProtectionRequirements = /* GraphQL */ `
  query DataProtectionRequirements($id: String) {
    dataProtectionRequirements(id: $id) {
      statusCode
      body {
        data_protection_requirements_id
        data_jacket_id
        term_id
        qualification_required
        data_management_requirement
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const priceBilling = /* GraphQL */ `
  query PriceBilling($id: String) {
    priceBilling(id: $id) {
      statusCode
      body {
        price_billing_id
        data_jacket_id
        term_id
        claim_type
        billing_unit
        price_range
        special_notes_data_sale
        billing_frequency
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const dataRecord = /* GraphQL */ `
  query DataRecord($id: String) {
    dataRecord(id: $id) {
      statusCode
      body {
        record_id
        data_jacket_id
        dataset_id
        record_name
        update_description
        registration_date
        information_update_modification_date
        last_update_user
        target_area
        target_area_resolution
        dataset_version
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const dataRecordIDs = /* GraphQL */ `
  query DataRecordIDs($id: String) {
    dataRecordIDs(id: $id) {
      statusCode
      ids
      __typename
    }
  }
`;
export const dataset = /* GraphQL */ `
  query Dataset($id: String) {
    dataset(id: $id) {
      statusCode
      body {
        dataset_id
        data_jacket_id
        record_id
        dataset_title
        dataset_language
        dataset_target_start
        dataset_target_end
        dataset_provision_frequency
        dataset_preprocessing_presence
        dataset_preprosessing
        dataset_identifier
        source
        dataset_description
        dataset_additional_infomation
        dataset_storage_format
        dataset_sharing_conditions
        access_right
        dataset_byte_size
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const datasetIDs = /* GraphQL */ `
  query DatasetIDs($id: String) {
    datasetIDs(id: $id) {
      statusCode
      ids
      __typename
    }
  }
`;
export const file = /* GraphQL */ `
  query File($id: String) {
    file(id: $id) {
      statusCode
      body {
        file_id
        data_jacket_id
        record_id
        dataset_id
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const fileHeader = /* GraphQL */ `
  query FileHeader($id: String, $subid: String) {
    fileHeader(id: $id, subid: $subid) {
      statusCode
      body {
        file_header_id
        file_item_sequence_number
        data_jacket_id
        record_id
        dataset_id
        item_id
        item_name
        item_description
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const fileHeaderIDs = /* GraphQL */ `
  query FileHeaderIDs($id: String) {
    fileHeaderIDs(id: $id) {
      statusCode
      ids
      __typename
    }
  }
`;
export const fileHeaderItems = /* GraphQL */ `
  query FileHeaderItems($id: String) {
    fileHeaderItems(id: $id) {
      statusCode
      body {
        item_names
        item_descriptions
        __typename
      }
      __typename
    }
  }
`;
export const fileRawData = /* GraphQL */ `
  query FileRawData($id: String) {
    fileRawData(id: $id) {
      statusCode
      body {
        file_raw_data_id
        data_jacket_id
        record_id
        dataset_id
        file_id
        raw_data
        author
        created_date
        update_user
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const relatedIndustryList = /* GraphQL */ `
  query RelatedIndustryList($empty: String) {
    relatedIndustryList(empty: $empty) {
      statusCode
      list
      __typename
    }
  }
`;
export const availabilityList = /* GraphQL */ `
  query AvailabilityList($empty: String) {
    availabilityList(empty: $empty) {
      statusCode
      list
      __typename
    }
  }
`;
export const sortOrderList = /* GraphQL */ `
  query SortOrderList($empty: String) {
    sortOrderList(empty: $empty) {
      statusCode
      list
      __typename
    }
  }
`;
export const nodeInfo = /* GraphQL */ `
  query NodeInfo($id: String, $userId: String) {
    nodeInfo(id: $id, userId: $userId) {
      statusCode
      body {
        id
        name
        raw_data
        node_ids
        node_names
        node_raw_datas
        node_similarity
        node_relation_words
        __typename
      }
      __typename
    }
  }
`;
export const statistics = /* GraphQL */ `
  query Statistics($id: String) {
    statistics(id: $id) {
      statusCode
      body {
        item
        type
        unit
        unique_num
        loss
        mean
        standard
        median
        min
        max
        __typename
      }
      __typename
    }
  }
`;
export const rawData = /* GraphQL */ `
  query RawData($id: String) {
    rawData(id: $id) {
      statusCode
      body {
        items
        type
        label
        data
        unit
        isNumber
        data001
        data002
        data003
        data004
        data005
        data006
        data007
        data008
        data009
        data010
        data011
        data012
        data013
        data014
        data015
        data016
        data017
        data018
        data019
        data020
        data021
        data022
        data023
        data024
        data025
        data026
        data027
        data028
        data029
        data030
        data031
        data032
        data033
        data034
        data035
        data036
        data037
        data038
        data039
        data040
        data041
        data042
        data043
        data044
        data045
        data046
        data047
        data048
        data049
        data050
        data051
        data052
        data053
        data054
        data055
        data056
        data057
        data058
        data059
        data060
        data061
        data062
        data063
        data064
        data065
        data066
        data067
        data068
        data069
        data070
        data071
        data072
        data073
        data074
        data075
        data076
        data077
        data078
        data079
        data080
        data081
        data082
        data083
        data084
        data085
        data086
        data087
        data088
        data089
        data090
        data091
        data092
        data093
        data094
        data095
        data096
        data097
        data098
        data099
        data100
        __typename
      }
      __typename
    }
  }
`;
export const countDataTable = /* GraphQL */ `
  query CountDataTable($empty: String) {
    countDataTable(empty: $empty) {
      statusCode
      count
      __typename
    }
  }
`;
export const countRawData = /* GraphQL */ `
  query CountRawData($empty: String) {
    countRawData(empty: $empty) {
      statusCode
      count
      __typename
    }
  }
`;
export const saveUserDataNetwork = /* GraphQL */ `
  query SaveUserDataNetwork(
    $userId: String
    $networkName: String
    $networkId: String
    $command: String
    $json: String
  ) {
    saveUserDataNetwork(
      userId: $userId
      networkName: $networkName
      networkId: $networkId
      command: $command
      json: $json
    ) {
      statusCode
      __typename
    }
  }
`;
export const getUserDataNetwork = /* GraphQL */ `
  query GetUserDataNetwork($userId: String) {
    getUserDataNetwork(userId: $userId) {
      statusCode
      json
      __typename
    }
  }
`;
export const announcementAcquisition = /* GraphQL */ `
  query AnnouncementAcquisition($empty: String) {
    announcementAcquisition(empty: $empty) {
      statusCode
      body {
        text
        __typename
      }
      __typename
    }
  }
`;
export const datajacketImageAcquisition = /* GraphQL */ `
  query DatajacketImageAcquisition($datajacketId: String) {
    datajacketImageAcquisition(datajacketId: $datajacketId) {
      statusCode
      body {
        img
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketgetUserId = /* GraphQL */ `
  query MyDataJacketgetUserId($userId: String) {
    myDataJacketgetUserId(userId: $userId) {
      statusCode
      body {
        id
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketList = /* GraphQL */ `
  query MyDataJacketList($myDataJacketId: String) {
    myDataJacketList(myDataJacketId: $myDataJacketId) {
      statusCode
      body {
        data_jacket_name
        data_jacket_summary
        data_jacket_industry
        created_date
        my_data_jacket_id
        data_jacket_collection
        data_jacket_free_text
        update_date
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketUpdateName = /* GraphQL */ `
  query MyDataJacketUpdateName(
    $dataJacketName: String
    $myDataJacketId: String
  ) {
    myDataJacketUpdateName(
      dataJacketName: $dataJacketName
      myDataJacketId: $myDataJacketId
    ) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketDelete = /* GraphQL */ `
  query MyDataJacketDelete($myDataJacketId: String) {
    myDataJacketDelete(myDataJacketId: $myDataJacketId) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketGetImage = /* GraphQL */ `
  query MyDataJacketGetImage($myDataJacketId: String) {
    myDataJacketGetImage(myDataJacketId: $myDataJacketId) {
      statusCode
      body {
        img
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketsortOrderList = /* GraphQL */ `
  query MyDataJacketsortOrderList(
    $userId: String
    $sortOrder: String
    $limit: Int
    $offset: Int
  ) {
    myDataJacketsortOrderList(
      userId: $userId
      sortOrder: $sortOrder
      limit: $limit
      offset: $offset
    ) {
      statusCode
      body {
        ids
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketInsert = /* GraphQL */ `
  query MyDataJacketInsert(
    $userId: String
    $dataJacketName: String
    $dataJacketSummary: String
    $dataJacketIndustry: String
    $dataJacketCollection: String
    $dataJacketFreeText: String
  ) {
    myDataJacketInsert(
      userId: $userId
      dataJacketName: $dataJacketName
      dataJacketSummary: $dataJacketSummary
      dataJacketIndustry: $dataJacketIndustry
      dataJacketCollection: $dataJacketCollection
      dataJacketFreeText: $dataJacketFreeText
    ) {
      statusCode
      body {
        my_data_jacket_id
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketReturnId = /* GraphQL */ `
  query MyDataJacketReturnId($userId: String, $dataJacketName: String) {
    myDataJacketReturnId(userId: $userId, dataJacketName: $dataJacketName) {
      statusCode
      body {
        my_data_jacket_id
        __typename
      }
      __typename
    }
  }
`;
export const myDataJacketReturnName = /* GraphQL */ `
  query MyDataJacketReturnName($userId: String) {
    myDataJacketReturnName(userId: $userId) {
      statusCode
      body {
        my_data_jacket_name
        __typename
      }
      __typename
    }
  }
`;
export const favoriteRegistrationRelease = /* GraphQL */ `
  query FavoriteRegistrationRelease(
    $userId: String
    $dataJacketId: String
    $favoriteFlag: Boolean
  ) {
    favoriteRegistrationRelease(
      userId: $userId
      dataJacketId: $dataJacketId
      favoriteFlag: $favoriteFlag
    ) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJgetUserId = /* GraphQL */ `
  query MyConnectDJgetUserId($userId: String) {
    myConnectDJgetUserId(userId: $userId) {
      statusCode
      body {
        ids
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJList = /* GraphQL */ `
  query MyConnectDJList($myConnectDJId: String) {
    myConnectDJList(myConnectDJId: $myConnectDJId) {
      statusCode
      body {
        my_connect_dj_id
        user_id
        connect_dj_name
        connect_dj_summary
        created_date
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJUpdateName = /* GraphQL */ `
  query MyConnectDJUpdateName($myConnectDJId: String, $connectDJName: String) {
    myConnectDJUpdateName(
      myConnectDJId: $myConnectDJId
      connectDJName: $connectDJName
    ) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJDelete = /* GraphQL */ `
  query MyConnectDJDelete($myConnectDJId: String) {
    myConnectDJDelete(myConnectDJId: $myConnectDJId) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJsortOrderList = /* GraphQL */ `
  query MyConnectDJsortOrderList(
    $userId: String
    $sortOrder: String
    $limit: Int
    $offset: Int
  ) {
    myConnectDJsortOrderList(
      userId: $userId
      sortOrder: $sortOrder
      limit: $limit
      offset: $offset
    ) {
      statusCode
      body {
        ids
        __typename
      }
      __typename
    }
  }
`;
export const myCoonectDJtGetImage = /* GraphQL */ `
  query MyCoonectDJtGetImage($myConnectDJId: String) {
    myCoonectDJtGetImage(myConnectDJId: $myConnectDJId) {
      statusCode
      body {
        img
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJInsert = /* GraphQL */ `
  query MyConnectDJInsert(
    $userId: String
    $connectDJImage: String
    $connectDJName: String
    $connectDJSummary: String
    $jsonFiltered: String
    $jsonSimilarity: String
    $jsonAll: String
  ) {
    myConnectDJInsert(
      userId: $userId
      connectDJImage: $connectDJImage
      connectDJName: $connectDJName
      connectDJSummary: $connectDJSummary
      jsonFiltered: $jsonFiltered
      jsonSimilarity: $jsonSimilarity
      jsonAll: $jsonAll
    ) {
      statusCode
      body {
        my_connect_dj_id
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJUpdate = /* GraphQL */ `
  query MyConnectDJUpdate(
    $myConnectDJId: String
    $connectDJImage: String
    $connectDJName: String
    $connectDJSummary: String
    $jsonFiltered: String
    $jsonSimilarity: String
    $jsonAll: String
  ) {
    myConnectDJUpdate(
      myConnectDJId: $myConnectDJId
      connectDJImage: $connectDJImage
      connectDJName: $connectDJName
      connectDJSummary: $connectDJSummary
      jsonFiltered: $jsonFiltered
      jsonSimilarity: $jsonSimilarity
      jsonAll: $jsonAll
    ) {
      statusCode
      body {
        my_connect_dj_id
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJGetUserDataNetwork = /* GraphQL */ `
  query MyConnectDJGetUserDataNetwork($myConnectDJId: String) {
    myConnectDJGetUserDataNetwork(myConnectDJId: $myConnectDJId) {
      statusCode
      body {
        json_filtered
        json_similarity
        json_all
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJInsertSave = /* GraphQL */ `
  query MyConnectDJInsertSave(
    $userId: String
    $jsonFiltered: String
    $jsonSimilarity: String
    $jsonAll: String
  ) {
    myConnectDJInsertSave(
      userId: $userId
      jsonFiltered: $jsonFiltered
      jsonSimilarity: $jsonSimilarity
      jsonAll: $jsonAll
    ) {
      statusCode
      body {
        result
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJGetUserDataNetworkSave = /* GraphQL */ `
  query MyConnectDJGetUserDataNetworkSave($userId: String) {
    myConnectDJGetUserDataNetworkSave(userId: $userId) {
      statusCode
      body {
        json_filtered
        json_similarity
        json_all
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJReturnId = /* GraphQL */ `
  query MyConnectDJReturnId($userId: String, $connectDJName: String) {
    myConnectDJReturnId(userId: $userId, connectDJName: $connectDJName) {
      statusCode
      body {
        my_connect_dj_id
        __typename
      }
      __typename
    }
  }
`;
export const myConnectDJReturnName = /* GraphQL */ `
  query MyConnectDJReturnName($userId: String) {
    myConnectDJReturnName(userId: $userId) {
      statusCode
      body {
        my_connect_dj_name
        __typename
      }
      __typename
    }
  }
`;
